"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyInputPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _propTypes = require("../propTypes");
const currencyInputPropTypes = exports.currencyInputPropTypes = {
  ..._propTypes.inputBasePropTypes,
  code: _stencilReactDesc.PropTypes.string.description('The currency code, e.g. "USD", "GBP".'),
  locale: _stencilReactDesc.PropTypes.string.description('Locale that will be used to format the currency. Should be an Intl-compatible string, such as "en-US".'),
  onChange: _stencilReactDesc.PropTypes.func.description('Callback function that will be called when the input is changed. It passes both the currency formatted string, and the number.').format('(e: React.ChangeEvent<HTMLInputElement>, formattedValue: string, unformattedValue: number) => void')
};